import { BlockList } from '@zillow/cms-blocks';
import { STICKY_SIDEBAR_TOP_PX } from '@zillow/zrs-cms';
import React, { ReactNode } from 'react';

import { Block } from '../../types/blocks';
import { PostsTemplate } from '../PostsTemplate';
import { PostsTemplateProps } from '../PostsTemplate/PostsTemplate.types';
import TermHero from '../TermHero/TermHero';

interface TermPageContentProps {
    term: {
        posts: PostsTemplateProps['posts'] & {
            total?: number;
        };
        description?: string;
        name: string;
        sidebar?: {
            blocks: Block[];
        };
        footer?: ReactNode;
        id: string;
        link: string;
    };
    initialPage: number;
}

const TermPageContent: React.FC<TermPageContentProps> = ({
    term,
    initialPage,
}) => (
    <PostsTemplate
        posts={term.posts}
        initialPage={initialPage}
        hero={
            <TermHero
                total={term.posts?.total}
                description={term.description}
                name={term.name}
            />
        }
        sidebar={
            term.sidebar ? (
                <BlockList blocks={term.sidebar?.blocks || []} />
            ) : null
        }
        stickySidebarTop={`${STICKY_SIDEBAR_TOP_PX}px`}
        footer={term.footer}
        archiveCategory={term.id}
        baseLink={term.link}
    />
);

export default TermPageContent;
